<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Settings" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="settings" pageId="holidays" color="white"></help-link>
                </v-toolbar>
            </v-card>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline style="margin-top:5px;">
                Error encountered. Please contact support. Error details: {{errorMessage}}
            </v-alert>  
            <v-card class="elavation-1" style="margin-top:5px;"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold">Select calendar period</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="fiscal_periods"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                    >
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" title="Click to View/Edit" style="cursor:pointer;">
                            <td>{{props.item.fiscalYear}}</td>
                            <td>{{props.item.fiscalStartDate|moment('MMMM D, YYYY')}}</td>
                            <td>{{props.item.fiscalEndDate|moment('MMMM D, YYYY')}}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.fiscalPeriodStatus)">{{commonfn.getStatusDescription(props.item.fiscalPeriodStatus)}}</b>
                            </td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.recordStatus)">{{commonfn.getStatusDescription(props.item.recordStatus)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>
    </v-layout>  
</template>
<script>

import holidasyApi from '@/api/holidays'
import commonfn from '@/common/functions'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default { 
    name: 'Holidays',
    metaInfo: {
        title: 'Holidays',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View and create holdays, so that all users can view in Team Calendar' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },    
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,
            loggedInTeamId: null,
            disabled: false,
            headers: [
                {text: 'Calendar Year',align: 'left',value: 'fiscalYear',width: '20%', sortable:true},
                {text: 'Start Date',align: 'left',value: 'fiscalStartDate',width: '20%', sortable:true},
                {text: 'End Date',align: 'left',value: 'fiscalEndDate',width: '20%', sortable:true},
                {text: 'Calendar Period Status',align: 'left',value: 'fiscalPeriodStatus',width: '20%', sortable:true},
                {text: 'Record Status',align: 'left',value: 'recordStatus',width: '20%', sortable:true},
            ],
            fiscal_periods: []
        }
    },
    methods: {     
        viewDetails(data) {
            this.$router.push(`/settings/holidays/${data.fiscalPeriodId}`)
        }, 
        async getFiscalPeriods() {
            try {
                this.loading = true
                const response = await holidasyApi.getMain() 
                if (response && response.status==200) {
                    this.fiscal_periods = response.data.fiscalPeriods
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Holidays'
        })

        this.getFiscalPeriods()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
    }
  }
</script>